import { faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container } from 'react-bootstrap';
import { type userSelector } from 'state/auth/auth.selectors';

interface Props {
  user: ReturnType<typeof userSelector>;
}

function LACTextV2({ user }: Props) {
  return (
    <>
      <Col
        xs={12}
        className="text-start"
      >
        <Container className="bg-light-gray border py-2">
          {user && <h5 className="fw-bold mb-1">{`Hello Dr. ${user.name}`}</h5>}
          <p className="m-0">You are one step away from being fully enrolled</p>
        </Container>
        <p className="text-purple mt-3 fw-bold">Notify Your Facility Administrator</p>
        <p>
          Per DEA requirements, enter the contact details of the individual authorized to grant
          final access for prescribing. This person is typically the practice or hospital
          administrator. They will receive an email containing instructions on how to complete the
          final step.
        </p>
        <p className="mt-2">
          Once the admin receives the access request, they will verify you are authorized to
          prescribe controlled substances and your DEA license #. Upon successful verification, the
          admin will grant you prescribing access.
        </p>
        <p className="fw-bold text-danger">
          NOTE: You will need to be present to enter your two-factor authentication credentials.
        </p>
      </Col>
    </>
  );
}

export default LACTextV2;
